










 

 









const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NewMeetingSettingsToggleTeamHealth_settings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phaseTypes",
      "storageKey": null
    }
  ],
  "type": "TeamMeetingSettings",
  "abstractKey": "__isTeamMeetingSettings"
};

(node ).hash = "0bda4936bdbb3a7fca649c73c2fe8585";

export default node;
